import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
interface NavProps {
  onBuyerContactOpen: () => void;
}
const navLinks = [{
  name: 'Buyers',
  path: '/buyers'
}, {
  name: 'Owners',
  path: '/owners'
}, {
  name: 'Sample Deal Brief',
  path: '/sample-deal-brief'
}, {
  name: 'Our Team',
  path: '/our-team'
}];
export function Nav({
  onBuyerContactOpen
}: NavProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0e0e0e]/90 backdrop-blur-md border-b border-white/[0.06]" data-id="element-113">
      <div className="max-w-7xl mx-auto px-6 lg:px-10" data-id="element-114">
        <div className="flex items-center justify-between h-20" data-id="element-115">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-id="element-116">
            <img src="https://cdn.magicpatterns.com/uploads/vdgv36ytuJeDtCVoSnd1Nw/DF_logo_.png" alt="Deal Flow" className="h-10 w-auto" data-id="element-117" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-10" data-id="element-118">
            {navLinks.map(link => <Link key={link.path} to={link.path} className="relative text-[13px] font-medium tracking-wide text-white/60 hover:text-white transition-colors duration-200 py-2 uppercase" data-id="element-119">
                {link.name}
                {location.pathname === link.path && <motion.div layoutId="nav-underline" className="absolute bottom-0 left-0 right-0 h-px bg-deal-green" transition={{
              type: 'spring',
              stiffness: 500,
              damping: 30
            }} data-id="element-120" />}
              </Link>)}
            <button onClick={onBuyerContactOpen} className="ml-2 px-5 py-2.5 bg-deal-green text-black text-[13px] font-semibold tracking-wide uppercase hover:bg-deal-green-dark transition-all duration-300" data-id="element-121">
              Start a Pilot
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2 text-white/60 hover:text-white transition-colors" aria-label="Toggle menu" data-id="element-122">
            {mobileMenuOpen ? <XIcon className="w-5 h-5" data-id="element-123" /> : <MenuIcon className="w-5 h-5" data-id="element-124" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-125">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.3
      }} className="md:hidden bg-[#0e0e0e] border-t border-white/[0.06] overflow-hidden" data-id="element-126">
            <div className="px-6 py-6 space-y-4" data-id="element-127">
              {navLinks.map((link, index) => <motion.div key={link.path} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: index * 0.1
          }} data-id="element-128">
                  <Link to={link.path} onClick={() => setMobileMenuOpen(false)} className={`block text-sm font-medium tracking-wide uppercase py-2 transition-colors ${location.pathname === link.path ? 'text-deal-green' : 'text-white/60 hover:text-white'}`} data-id="element-129">
                    {link.name}
                  </Link>
                </motion.div>)}
              <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.3
          }} data-id="element-130">
                <button onClick={() => {
              setMobileMenuOpen(false);
              onBuyerContactOpen();
            }} className="w-full mt-4 px-5 py-3 bg-deal-green text-black text-sm font-semibold tracking-wide uppercase hover:bg-deal-green-dark transition-all duration-300" data-id="element-131">
                  Start a Pilot
                </button>
              </motion.div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}